import { Helmet } from "react-helmet-async";

const SITE_NAME = "ProspoAI";
const SITE_URL = "https://prospo-ai-dsbnamgtc5dsenhe.australiacentral-01.azurewebsites.net";

interface SeoHeadProps {
  title: string;
  description: string;
  path: string;
  /** Public marketing/auth pages should be indexed; authenticated app pages should not. */
  index?: boolean;
}

/**
 * Sets per-page title/meta tags for the small set of public (unauthenticated) routes.
 * Authenticated app pages rely on the `noindex, nofollow` default set in index.html
 * and don't need this component.
 */
const SeoHead: React.FC<SeoHeadProps> = ({ title, description, path, index = true }) => {
  const fullTitle = `${title} — ${SITE_NAME}`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={index ? "index, follow" : "noindex, nofollow"} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SeoHead;
